module.exports = __webpack_public_path__ + "static/media/visitor.11dd1b52.png";